import * as React from 'react';
import classNames from 'classnames';

import get from 'lodash/get';

import { AreaLayout } from './AreaLayout';
import { AreaSettings } from './AreaSettings';

/**
 * Renders an area proxy enabling the edition of the icon and label position
 * and, through an expandable inspector, the edition of styling properties.
 */
export class Area extends React.PureComponent {
    constructor(props) {
        super(props);
        this.toggleActive = (occurrence) => this.props.onToggle(this.props.name, occurrence);
    }

    render() {
        const { value, name: key, active, onChange, defaults, state, onChangeState, hide } = this.props;
        const display = get(value, 'main.display', 'block');

        return (
            <div
                className={classNames(
                    'widget-style-area',
                    `widget-style-area--${key}`,
                    active && 'widget-style-area--is-active',
                    `widget-style-area--mode-${display}`,
                )}
            >
                <AreaLayout
                    hide={hide}
                    value={value}
                    name={key}
                    onChange={onChange}
                    defaults={defaults}
                    display={display}
                    onClick={this.toggleActive}
                />
                <div className="widget-style-area__settings">
                    {active && (
                        <AreaSettings
                            value={value}
                            onChange={onChange}
                            name={key}
                            defaults={defaults}
                            onChangeState={onChangeState}
                            state={state}
                        />
                    )}
                </div>
            </div>
        );
    }
}
